import React, { useEffect, useState } from "react";
import Text from "components/Text";
import RadioInput from "components/RadioInput";
import { Row, Column } from "components/Layout/Grid";
import Validator from "components/Validator";
import DomainSettingService from "services/domainSetting.service";
import { IDomainSetting } from "models/DomainSetting";
import { IProductSampleType } from './interface';

const ProductSampleType: React.FC<IProductSampleType> = (props) => {
  const {
    protocolCategory,
    uncontaminatedProductSampleType,
    setUncontaminatedProductSampleType,
    isEditing
  } = props;

  const [uncontaminatedProductSampleButtonsTypes, setUncontaminatedProductSampleButtonsTypes] = useState(
    Array<IDomainSetting>()
  );

  const _domainSettingService = new DomainSettingService();

  useEffect(() => {
    _domainSettingService
      .get(undefined, undefined, undefined, {
        and: [
          { identifier: { eq: "TicketUncontaminatedProductSample" } },

          { enabled: { eq: true } },
        ],
      })
      .then((result: any) => {
        if (result && result.data) {
          let _uncontaminatedProductSampleButtonTypes: Array<IDomainSetting> = result.data;

          setUncontaminatedProductSampleButtonsTypes(_uncontaminatedProductSampleButtonTypes);
        }
      });

  }, []);

  useEffect(() => {
    if (!isEditing) {
      setUncontaminatedProductSampleType('');
    }
  }, [protocolCategory]);

  return (
    <Column className="mt-5 flex-1">
      <Text className="mb-2 color-blue-gray" size={12}>
        Amostra do produto disponível para coleta
      </Text>
      <Validator value={uncontaminatedProductSampleType} name="Amostra do produto" required>
        <Row className="flex-md-column">
          {uncontaminatedProductSampleButtonsTypes.map((el, index) => (
            <Row key={index} className="w-md-100 mt-md-2 mr-4">
              <RadioInput
                id={el.key}
                onClick={() => setUncontaminatedProductSampleType(el.value || '')}
                checked={uncontaminatedProductSampleType === el.value}
              >
                <Text className="color-blue-gray">{el.description}</Text>
              </RadioInput>
            </Row>
          ))}
        </Row>
      </Validator>
    </Column>
  );
};

export default ProductSampleType;
